import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { ConfirmButton } from 'components/common';

const PathAccessUsersRemoveAll = connect(state => state)(class extends Component {
  removeUsers = async () => {
    const { pageState: { path }, updateUsers } = this.props;
    const response = await api.delete(`/admin/paths/${path.id}/users`);
    if (!response.data || !response.data.success) return false;
    await updateUsers({showLoading: false});
    return true;
  }

  render() {
    const { messages } = this.props;

    return (
      <ConfirmButton
        actionText={messages.commonRemove}
        buttonIcon="trash-alt"
        buttonText={messages.commonRemoveAll}
        category="danger"
        confirmText={messages.pathsUsersRemoveAllConfirm}
        confirmTitle={messages.commonRemoveAllUsers}
        onConfirm={this.removeUsers}
        successMessage={messages.commonRemoveAllUsersSuccess}
      />
    );
  }
});

export default PathAccessUsersRemoveAll;
